import type { Dictionary } from '@/i18n/types';

export const en: Dictionary = {
  hero: {
    title: 'Is there a Vammo station near you?',
    subtitle: 'Enter your postal code and see the closest battery swap station.',
  },
  form: {
    cepLabel: 'Your postal code',
    cepPlaceholder: '00000-000',
    submit: 'Find the closest station',
    useLocation: 'Use my location',
    invalidCep: 'Enter a postal code with 8 digits.',
    busy: 'Searching...',
  },
  result: {
    nearestStation: 'Closest station',
    supportedModels: 'Models served',
    distanceNote: 'Straight-line distance, from your postal code to the station.',
    stationsWithin: (count: number, radiusKm: number) =>
      count === 1
        ? `1 station within ${radiusKm} km`
        : `${count} stations within ${radiusKm} km`,
    openNow: 'Open now',
    closedNow: 'Closed now',
    snapshotNotice: 'Station list from the last update.',
    changeCep: 'Search another postal code',
  },
  ladder: {
    ariaLabel: (range: string) => `Distance band: ${range}`,
    upTo: (km: number) => `up to ${km} km`,
    between: (from: number, to: number) => `from ${from} to ${to} km`,
    above: (km: number) => `${km} km or more`,
    outOfRegion: 'outside the service area',
  },
  bands: {
    excellent: {
      title: 'The network is excellent around you',
      body: 'You have a swap station minutes from home. Swap the battery whenever you want.',
    },
    covered: {
      title: 'You are well covered',
      body: 'The closest station is near you. Swap on your way back from work, even at 50% battery. That way you never run out of charge.',
    },
    limited: {
      title: 'It works every day, with a routine',
      body: 'Many riders at this distance ride every day. The secret is routine. Always swap at the same time, near work or on your way home. The network in your region is still limited and it will grow.',
    },
    far: {
      title: 'The network is far from you today',
      body: 'The closest station is far for daily use. We recommend you wait for a closer station. Talk to us and we will tell you when we open in your region.',
    },
    out_of_region: {
      title: 'We have not reached your city yet',
      body: 'Vammo serves Greater São Paulo today. Talk to us and we will tell you when we get close to you.',
    },
  },
  errors: {
    invalid_cep: 'Enter a postal code with 8 digits.',
    cep_not_found: 'We did not find this postal code. Check the digits.',
    imprecise:
      'We could not locate this postal code precisely. Use your phone location to see the closest station.',
    unavailable: 'The search failed now. Try again or use your location.',
    geolocation_denied: 'You did not allow location access. Enter your postal code.',
    geolocation_unavailable: 'Your browser did not report a location. Enter your postal code.',
    no_stations: 'We could not load the stations now. Try again.',
  },
  map: {
    unavailable: 'Your browser does not show the map. See the station list below.',
    listTitle: 'Closest stations',
    youAreHere: 'You are here',
    legend: {
      both: 'Comfort and CPX',
      comfortOnly: 'Comfort only',
      cpxOnly: 'CPX only',
    },
  },
  footer: {
    privacy: 'We do not store your postal code or your location.',
    language: 'Language',
  },
};
